import { iCompanyOwner } from "../../types";
import "../../css/UserEditModal.css";
import "../../css/SiteAdminModals.css";

interface DeleteModalProps {
    isOpen: boolean;
    onClose: () => void;
    ownerInfo: iCompanyOwner | null;
    onDeleteOwner: () => void;
    onDeleteCompany: (companyId: string) => void;
    isConfirmed: boolean;
    onConfirmChange: (checked: boolean) => void;
}

const formatSubType = (type: string) => {
    switch (type) {
        case "paid-full-access": return "SA – FA";
        case "paid-limited-access": return "SA – LA";
        case "free-demo": return "SA – FD";
        case "paused": return "SA – P";
        default: return type;
    }
};

export const DeleteModal = ({
    isOpen, onClose, ownerInfo, onDeleteOwner, onDeleteCompany, isConfirmed, onConfirmChange,
}: DeleteModalProps) => {
    if (!isOpen || !ownerInfo) return null;

    const handleClose = () => {
        onConfirmChange(false);
        onClose();
    };

    return (
        <div className="uem-overlay" onClick={handleClose}>
            <div className="uem-modal" onClick={(e) => e.stopPropagation()}>
                <div className="uem-header">
                    <h2>Delete Company / Owner</h2>
                    <button className="uem-close" onClick={handleClose} aria-label="Close modal">×</button>
                </div>
                <div className="uem-body">
                    <div className="uem-warning-banner">
                        <span className="uem-warning-icon">⚠</span>
                        <span>This action is permanent and cannot be undone. All company data, users, and records will be deleted.</span>
                    </div>

                    <div className="uem-confirm-row">
                        <input
                            type="checkbox"
                            checked={isConfirmed}
                            onChange={(e) => onConfirmChange(e.target.checked)}
                            id="delete-confirm"
                        />
                        <label className="uem-confirm-text" htmlFor="delete-confirm">
                            I understand this will permanently delete <strong>{ownerInfo.name} ({formatSubType(ownerInfo.subscriptionType)})</strong> and all associated data.
                        </label>
                    </div>

                    <button
                        type="button"
                        className="uem-btn-submit"
                        style={{ background: "#c0392b", width: "100%", marginBottom: 16 }}
                        disabled={!isConfirmed}
                        onClick={onDeleteOwner}
                    >
                        Delete {ownerInfo.name}
                    </button>

                    {ownerInfo.company?.length > 0 && (
                        <>
                            <div className="uem-delete-section-label">Also Delete Company</div>
                            {ownerInfo.company.map((company) => (
                                <div key={company.id} className="uem-delete-company-card">
                                    <div className="uem-delete-company-name">{company.name}</div>
                                    <div className="uem-delete-company-desc">{company.description || company.businessType || "—"}</div>
                                    <button
                                        type="button"
                                        className="uem-btn-delete-company"
                                        disabled={!isConfirmed}
                                        onClick={() => onDeleteCompany(company.id)}
                                    >
                                        Delete Company Data
                                    </button>
                                </div>
                            ))}
                        </>
                    )}
                </div>
                <div className="uem-footer">
                    <button type="button" className="uem-btn-cancel" onClick={handleClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
};
